import {Component, OnInit, TemplateRef} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ApiService, Tables} from "../../../services/api.service";
import {Malfunction} from "../../../shared/interfaces/malfunction";
import {SelectionService} from "../../../services/selection.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbOffcanvas} from "@ng-bootstrap/ng-bootstrap";
import {MatButtonModule} from "@angular/material/button";
import {MatChipsModule} from "@angular/material/chips";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatIconModule} from "@angular/material/icon";
import {MatTreeModule} from "@angular/material/tree";

@Component({
  selector: "app-kd-malfunction",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatChipsModule,
    MatExpansionModule,
    MatIconModule,
    MatTreeModule,
  ],
  templateUrl: "./kd-malfunction.component.html",
  styleUrls: ["./kd-malfunction.component.scss"],
})
export class KdMalfunctionComponent implements OnInit {
  public malfunctions: Malfunction[] = [];
  activePage = 1;
  categoryId: string = "";
  selectedWorkplaceId: string = "";
  malfunctionId: string = "";
  expandedItems: any = [];

  constructor(
    private readonly apiService: ApiService,
    private readonly selectionService: SelectionService,
    private offcanvasService: NgbOffcanvas
  ) {
  }

  ngOnInit(): void {
    this.selectionService.activePage.subscribe((activePage) => {
      if (activePage == 0) {
        this.expandedItems = [];
      }
      this.activePage = activePage;
    });
    this.selectionService.currentWorkplace.subscribe((workplaceId) => {
      this.malfunctions = [];
      if (workplaceId) {
        this.selectedWorkplaceId = workplaceId;
      }
    });
    this.selectionService.currentMalfunction.subscribe((malfunctionId) => {
      if (malfunctionId) {
        this.malfunctionId = malfunctionId;
        this.updateMalfunctionData();
      }
    });
    this.selectionService.currentCategory.subscribe((categoryId) => {
      if (categoryId) {
        this.categoryId = categoryId;
        this.updateMalfunctionData();
      }
    });
  }

  updateMalfunctionData(): void {
    // if (this.categoryId.length > 0) {
    // // console.log.log('malfunction', this.malfunctionId)
    /* this.apiService.getMalfunctionById(this.malfunctionId)
      .then((data: any) => {
        this.malfunctions = data.data;
        // console.log('malfunction', this.malfunctions)
      }) */
    /* this.apiService.getMalfunctionsByCategory(this.categoryId).then((data:any) => {
        this.malfunctions = data.data;
      }) */
    // }
  }

  selectMalfunction(target: any) {
    let dataName = target.getAttribute("data-name");
    this.expandedItems = [];
    this.expandedItems.push(dataName);
    // // console.log.log(this.expandedItems);
    this.selectionService.changeMalfunction(target.getAttribute("data-index"));
    this.selectionService.changeActivePage(2);
  }

  openOffcanvas(content: TemplateRef<any>) {
    this.selectionService.changeActivePage(1);
    this.offcanvasService.open(content, {
      position: "end",
      backdrop: "static",
    });
  }

  insertMalfunction(malfunction: Malfunction) {
    if (this.selectedWorkplaceId && this.categoryId) {
      malfunction.workplace = this.selectedWorkplaceId;
      malfunction.category = this.categoryId;
      this.apiService
        .insertItem(Tables.Malfunction, malfunction)
        .then((data) => {
          this.offcanvasService.dismiss();
          this.selectionService.changeActivePage(0);
          // this.updateMalfunctionData()
        });
    }
  }
}
